<!-- Main Workspace Layout -->
<as-split direction="horizontal" class="main-split">
  <!-- Chat Panel (Left) -->
  <as-split-area [size]="30" class="chat-panel">
    <chat class="h-full w-full" [sessionId]="sessionId" [shell]="shellComponent"></chat>
  </as-split-area>

  <!-- Editor Panel (Right) -->
  <as-split-area [size]="70" class="editor-panel">
    <div class="h-full w-full flex flex-col">
      <!-- Tabs Header (if multiple tabs) -->
      @if(tabList.length > 1) {
      <div role="tablist" class="tabs-container">
        @for(tb of tabList; track tb){
        <button class="tab-btn" [class.active]="activeTab.label === tb.label"
          (click)="switchTab(tb)">{{tb.label}}</button>
        }
      </div>
      }

      <!-- Main Content Area -->
      <div class="content-area">
        @if(activeTab.label === 'Editor') {
        <as-split direction="vertical" [gutterSize]="8" class="editor-split">
          <!-- Combined Editor Panel (Files + Viewer) -->
          <as-split-area [size]="80">
            <div class="editor-card">
              <as-split direction="horizontal" [gutterSize]="4" class="editor-inner-split">
                <!-- File Sidebar -->
                <as-split-area [size]="20" [minSize]="10" [maxSize]="40" class="sidebar-area">
                  <div class="file-sidebar">
                    <div class="sidebar-header">Files</div>
                    <div class="sidebar-content">
                      @if(node) {
                      <explorer class="h-full w-full" [node]="node"></explorer>
                      } @else {
                      <div class="empty-state">
                        <p>No files</p>
                      </div>
                      }
                    </div>
                  </div>
                </as-split-area>
                <!-- Code Viewer -->
                <as-split-area [size]="80" class="viewer-area">
                  <app-viewer class="h-full w-full"></app-viewer>
                </as-split-area>
              </as-split>
            </div>
          </as-split-area>

          <!-- Terminal -->
          <as-split-area [size]="20" class="terminal-area">
            <shell class="w-full h-full" #shellComponent></shell>
          </as-split-area>
        </as-split>
        } @else {
        <div class="dynamic-content">
          <ng-container *ngComponentOutlet="dynamicComponent"></ng-container>
        </div>
        }
      </div>
    </div>
  </as-split-area>
</as-split>